/* eslint-disable indent */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable operator-linebreak */
import { AlertAdapter } from 'pg-ui-library';
import { Dispatch } from 'redux';
import { IContact, IDependent, IEmployeeAuditable, IPayStatement } from 'src/interfaces';

import { IEmployee } from 'src/interfaces/employee';
import EmployeesService, {
  IEmployeeBaseParams,
  IEmployeeBaseParamsWithPagination,
  IGetEmployeeServiceParams,
} from 'src/services/employees.service';

import { EmployeesActionType } from '../action-types';
import { EmployeesAction } from '../actions';

export const getEmployees = (params: IGetEmployeeServiceParams) => async (dispatch: Dispatch<EmployeesAction>) => {
  dispatch({
    type: EmployeesActionType.GET_EMPLOYEES,
  });

  try {
    const { data }: { data: { items: IEmployee[]; meta: { totalItems: number } } } =
      await EmployeesService.getEmployees(params);
    dispatch({
      type: EmployeesActionType.GET_EMPLOYEES_SUCCESS,
      payload: {
        employees: data.items,
        employeesStatus: params.employeeStatus,
        totalEmployees: data.meta.totalItems,
      },
    });
  } catch (err: any) {
    dispatch({
      type: EmployeesActionType.GET_EMPLOYEES_FAILURE,
      payload: err.message,
    });
  }
};

export const getEmployeesWithUserActive =
  (params: IGetEmployeeServiceParams) => async (dispatch: Dispatch<EmployeesAction>) => {
    dispatch({
      type: EmployeesActionType.GET_EMPLOYEES,
    });

    try {
      const { data }: { data: { items: IEmployee[]; meta: { totalItems: number } } } =
        await EmployeesService.getEmployeesWithUserActive(params);
      dispatch({
        type: EmployeesActionType.GET_EMPLOYEES_SUCCESS,
        payload: {
          employees: data.items,
          employeesStatus: params.employeeStatus,
          totalEmployees: data.meta.totalItems,
        },
      });
    } catch (err: any) {
      dispatch({
        type: EmployeesActionType.GET_EMPLOYEES_FAILURE,
        payload: err.message,
      });
    }
  };

export const setSelectedEmployee = (employee: IEmployee) => async (dispatch: Dispatch<EmployeesAction>) => {
  dispatch({
    type: EmployeesActionType.SET_EMPLOYEE,
    payload: { selectedEmployee: employee },
  });
};

export const getEmployeeDependents =
  (params: IEmployeeBaseParamsWithPagination) => async (dispatch: Dispatch<EmployeesAction>) => {
    dispatch({
      type: EmployeesActionType.GET_EMPLOYEE_DEPENDENTS,
    });

    try {
      const { data }: { data: { items: IDependent[]; meta: { totalItems: number } } } =
        await EmployeesService.getEmployeeDependents(params);

      dispatch({
        type: EmployeesActionType.GET_EMPLOYEE_DEPENDENTS_SUCCESS,
        payload: {
          dependents: data.items,
          totalDependents: data.meta.totalItems,
        },
      });
    } catch (err: any) {
      dispatch({
        type: EmployeesActionType.GET_EMPLOYEE_DEPENDENTS_FAILURE,
        payload: err.message,
      });
    }
  };

export const getEmployeeContacts =
  (params: IEmployeeBaseParamsWithPagination) => async (dispatch: Dispatch<EmployeesAction>) => {
    dispatch({
      type: EmployeesActionType.GET_EMPLOYEE_CONTACTS,
    });

    try {
      const { data }: { data: { items: IContact[]; meta: { totalItems: number } } } =
        await EmployeesService.getEmployeeContacts(params);

      dispatch({
        type: EmployeesActionType.GET_EMPLOYEE_CONTACTS_SUCCESS,
        payload: {
          contacts: data.items,
          totalContacts: data.meta.totalItems,
        },
      });
    } catch (err: any) {
      dispatch({
        type: EmployeesActionType.GET_EMPLOYEE_CONTACTS_FAILURE,
        payload: err.message,
      });
    }
  };

export const getEmployeeAuditable =
  (params: IEmployeeBaseParamsWithPagination) => async (dispatch: Dispatch<EmployeesAction>) => {
    dispatch({
      type: EmployeesActionType.GET_EMPLOYEE_AUDITABLE,
    });

    try {
      const {
        data,
      }: {
        data: { items: IEmployeeAuditable[]; meta: { totalItems: number } };
      } = await EmployeesService.getEmployeeAuditable(params);

      dispatch({
        type: EmployeesActionType.GET_EMPLOYEE_AUDITABLE_SUCCESS,
        payload: {
          auditable: data.items,
          totalAuditable: data.meta.totalItems,
        },
      });
    } catch (err: any) {
      dispatch({
        type: EmployeesActionType.GET_EMPLOYEE_AUDITABLE_FAILURE,
        payload: err.message,
      });
    }
  };

export const getEmployeePayStatements =
  (params: IEmployeeBaseParamsWithPagination) => async (dispatch: Dispatch<EmployeesAction>) => {
    dispatch({
      type: EmployeesActionType.GET_EMPLOYEE_PAY_STATEMENTS,
    });

    try {
      const {
        data,
      }: {
        data: { items: IPayStatement[]; meta: { totalItems: number } };
      } = await EmployeesService.getEmployeePayStatements(params);

      dispatch({
        type: EmployeesActionType.GET_EMPLOYEE_PAY_STATEMENTS_SUCCESS,
        payload: {
          payStatements: data.items,
          totalPayStatements: data.meta.totalItems,
        },
      });
    } catch (err: any) {
      dispatch({
        type: EmployeesActionType.GET_EMPLOYEE_PAY_STATEMENTS_FAILURE,
        payload: err.message,
      });
    }
  };

export const patchEmployeeAccess =
  (params: IEmployeeBaseParams & { permissionId: string }) => async (dispatch: Dispatch<EmployeesAction>) => {
    dispatch({
      type: EmployeesActionType.PATCH_EMPLOYEE_ACCESS,
    });

    try {
      await EmployeesService.patchEmployeeAccess({
        ...params,
      });

      dispatch({
        type: EmployeesActionType.PATCH_EMPLOYEE_ACCESS_SUCCESS,
        payload: {
          ...params,
        },
      });
    } catch (err: any) {
      dispatch({
        type: EmployeesActionType.PATCH_EMPLOYEE_ACCESS_FAILURE,
        payload: err.message,
      });
    }
  };

export const disconnectEmployeeAccess =
  (employeeId: string, companyId: string) => async (dispatch: Dispatch<EmployeesAction>) => {
    dispatch({
      type: EmployeesActionType.DISCONNECT_EMPLOYEE_ACCESS,
    });

    try {
      await EmployeesService.disconnectEmployee({
        companyId,
        employeeId,
      });

      dispatch({
        type: EmployeesActionType.DISCONNECT_EMPLOYEE_ACCESS_SUCCESS,
        payload: {
          employeeId,
        },
      });

      AlertAdapter('Employee disconnected successfully!', 'success');
    } catch (err: any) {
      dispatch({
        type: EmployeesActionType.DISCONNECT_EMPLOYEE_ACCESS_FAILURE,
        payload: err.message,
      });
      AlertAdapter('Failed to disconnect employee account', 'error');
    }
  };
